import {useEffect, useState} from "react";
import {cfgAdd, cfgPartial, cfgUpdate, getMenus} from "../api/api";
import dayjs from "dayjs";
import BottomSheet from "../components/BottomSheet"; // Install via: npm install dayjs
import Select from 'react-select'
import {useApp} from "../Contex";


export default function Hours() {
    const {refresh, permissions:{write}} = useApp()
    const [hours, setHours] = useState({});
    const [specialMenu, setSpecialMenu] = useState({});
    const [changedGeneral, setChangedGeneral] = useState(false);
    const [changedCalender, setChangedCalender] = useState(false);


    const [fullMenu, setFullMenu] = useState([]);

    function fetchData() {
        cfgPartial(["hours", "spcmnu"]).then((res) => {
            if (res.ok) {
                setHours(res.data.hours);
                setSpecialMenu(res.data.spcmnu); // if needed
            }
        });
    }

    useEffect(() => {
        fetchData();
        getMenus().then((res)=>{
            let arr = []
            if(res.ok){
                res.data.forEach((item) => {
                    const i = {value: item.gid, label: item.text}
                    arr.push(i)
                })
                setFullMenu(arr)
            }
            }
        )
    }, [refresh]);

    const handleHourChange = (path, newValue) => {
        setHours(prev => updateNested(prev, path, newValue));
    };

    function updateNested(obj, path, newValue) {
        const keys = path.split('.');
        const lastKey = keys.pop();
        const deepClone = structuredClone(obj);

        let temp = deepClone;
        for (const key of keys) {
            if (temp[key] === undefined) temp[key] = {};
            temp[key] = { ...temp[key] };
            temp = temp[key];
        }
        temp[lastKey] = newValue;
        return deepClone;
    }


    function TimeInput({ title, path, value, onChange }) {
        const toTimeInputFormat = (hhmm) => {
            if (!hhmm || hhmm.length !== 4) return '';
            if (hhmm === '2400') return '00:00'; // special case
            return hhmm.slice(0, 2) + ':' + hhmm.slice(2);
        };

        const fromTimeInputFormat = (timeStr) => {
            if (!timeStr || timeStr.length !== 5) return '';
            return timeStr === '00:00' ? '2400' : timeStr.replace(':', '');
        };

        const handleChange = (e) => {
            setChangedGeneral(true)
            const newValue = fromTimeInputFormat(e.target.value);
            onChange(path, newValue);
        };

        return (
            <>
                <label className="form-label">{title}</label>
                <input
                    type="time"
                    value={toTimeInputFormat(value)}
                    onChange={handleChange}
                    className="form-control w-auto"
                    disabled={!write}
                />
            </>

        );
    }

    function handleSave(){
        cfgUpdate({hours}).then((res) => {
            if (res.ok) {
                fetchData()
                setChangedGeneral(false)
            }
        })
    }

    function CalenderOC({ hours, menu }) {
        const [spo, setSpo] = useState(hours?.spo ?? {});
        const [spc, setSpc] = useState(hours?.spc ?? {});
        const [spcmnu, setSpcmnu] = useState(menu ?? {})

        const [start, setStart] = useState(dayjs());
        const [daysToShow, setDayToShow] = useState(14);
        const [openDay, setOpenDay] = useState(false);

        const generateDates = () => {
            return Array.from({ length: daysToShow }, (_, i) =>
                start.add(i, 'day').format('YYYYMMDD')
            );
        };

        const addDays = () => setStart((prev) => prev.add(daysToShow, 'day'));
        const removeDays = () => setStart((prev) => prev.subtract(daysToShow, 'day'));

        const PageButtons = () => (
            <div className="d-flex justify-content-center gap-3 my-3">
                <button className="btn btn-outline-secondary" onClick={removeDays}>{"< Föregående"}</button>
                <button className="btn btn-outline-secondary" onClick={addDays}>{"Nästa >"}</button>
            </div>
        );

        const DayModal = ({ item, setItem }) => {
            const [changedOpeningTimes, setChangedOpeningTimes] = useState(false);
            const [changedOpen, setChangedOpen] = useState(false)
            const [openH, setOpenH] = useState({ ftid: "", ttid: "" });
            const [closed, setClosed] = useState(false);
            const [spcMenu, setSpcMenu] = useState({ftid: "", ttid: "", menus: []});

            const [showMenu, setShowMenu] = useState(false)
            const [changedMenu, setChangedMenu] = useState(false)

            useEffect(() => {
                    setOpenH(item?.hours ?? {ftid: "", ttid: "" })
                    setClosed(item?.status === "closed");
                    setChangedOpeningTimes(false);
                    setSpcMenu(item?.menu ?? {ftid: "", ttid: "", menus: []})
            }, [item]);

            if (!item) return null;

            const { date } = item;
            const dateFormatted = dayjs(date).format("dddd, D MMMM YYYY");

            const updateHours = (e, path, target = "openH") => {
                const value = e.target.value.replace(":", "");

                if (target === "openH") {
                    setOpenH((prev) => ({ ...prev, [path]: value }));
                    setChangedOpeningTimes(true);
                } else if (target === "spcMenu") {
                    setSpcMenu((prev) => ({ ...prev, [path]: value }));
                    setChangedMenu(true);
                }
            };

            const handleSave = () => {
                const dateKey = item.date.substring(2); // "250511"
                const updates = {};

                if (closed) {
                    updates[`hours.spc.${dateKey}`] = "1";
                    updates[`__unset`] = [`hours.spo.${dateKey}`, `spcmnu.${dateKey}`];
                } else {
                    if (changedOpeningTimes) updates[`hours.spo.${dateKey}`] = openH;
                    if (changedMenu) {
                        if (spcMenu.menus.length === 0) {
                            updates[`spcmnu.${dateKey}`] = null; // signal deletion
                        } else {
                            updates[`spcmnu.${dateKey}`] = spcMenu;
                        }
                    }

                    const unset = [];
                    if (!changedOpeningTimes) unset.push(`hours.spc.${dateKey}`);
                    if (!changedMenu) unset.push(`spcmnu.${dateKey}`);
                    if (unset.length) updates[`__unset`] = unset;
                }

                cfgUpdate(updates).then((res) => {
                    if(res.ok){
                        fetchData()
                        setItem(false);
                    }
                });
            };



            return (
                <BottomSheet show={item} setShow={setItem}>
                    <div>
                        <h4 className="mb-3">{dateFormatted}</h4>

                            <div className="d-flex align-items-center gap-3 mb-3">
                                <input
                                    className="form-control"
                                    type="time"
                                    value={openH.ftid ? openH.ftid.slice(0, 2) + ":" + openH.ftid.slice(2, 4) : ""}
                                    onChange={(e) => updateHours(e, 'ftid')}
                                />
                                <h3 className="mb-0">–</h3>
                                <input
                                    className="form-control"
                                    type="time"
                                    value={openH.ttid ? openH.ttid.slice(0, 2) + ":" + openH.ttid.slice(2, 4) : ""}
                                    onChange={(e) => updateHours(e, 'ttid')}
                                />
                            </div>

                            <div className="card">
                                <div className="p-3 d-flex align-items-center gap-2 fs-5" onClick={()=>{setShowMenu((prev)=>!prev)}}> <h5>Special Meny</h5> <i className={`bi ${showMenu ? "bi-caret-up" : "bi-caret-down"}`}></i></div>
                                {showMenu &&
                                    <div className="card-body bg-light">
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <input
                                                className="form-control"
                                                type="time"
                                                value={spcMenu.ftid ? `${spcMenu.ftid.slice(0, 2)}:${spcMenu.ftid.slice(2, 4)}` : ""}
                                                onChange={(e) => updateHours(e, "ftid", "spcMenu")}
                                            />
                                            <h3 className="mb-0">–</h3>
                                            <input
                                                className="form-control"
                                                type="time"
                                                value={spcMenu.ttid ? `${spcMenu.ttid.slice(0, 2)}:${spcMenu.ttid.slice(2, 4)}` : ""}
                                                onChange={(e) => updateHours(e, "ttid", "spcMenu")}
                                            />
                                        </div>
                                        <Select
                                            isMulti
                                            value={fullMenu.filter(opt => spcMenu.menus.includes(opt.value))}
                                            options={fullMenu}
                                            onChange={(selectedOptions) => {
                                                setSpcMenu(prev => ({
                                                    ...prev,
                                                    menus: selectedOptions.map(opt => opt.value)
                                                }));
                                                setChangedMenu(true);
                                            }}
                                        />

                                    </div>}
                            </div>

                        <div className="d-flex justify-content-between align-items-end mt-5">
                            <div className="d-flex gap-2 align-items-center py-2">
                                <h5 className="mb-0">Stängt</h5>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={closed}
                                    onChange={(e) => {
                                        setClosed(e.target.checked);
                                        setChangedOpen(true);
                                    }}
                                />
                            </div>
                            {(changedOpeningTimes || changedOpen || changedMenu) && (
                                <button className="btn btn-success" onClick={handleSave}>
                                    <i className="bi bi-save me-2"></i>Spara
                                </button>
                            )}
                        </div>
                    </div>
                </BottomSheet>
            );
        };



        return (
            <div className="container">
                <PageButtons />

                <div className="list-group">
                    {generateDates().map((dateStr) => {
                        const weekdayKey = String(dayjs(dateStr).day());

                        // 🔁 Determine resolved opening hours
                        let resolvedHours = null;
                        let status = 'none';

                        const menu = spcmnu[dateStr.substring(2)]

                        if (spc.hasOwnProperty(dateStr.substring(2))) {
                            status = 'closed';
                        } else if (spo[dateStr.substring(2)]?.ftid && spo[dateStr.substring(2)]?.ttid) {
                            resolvedHours = spo[dateStr.substring(2)];
                            status = 'special';
                        } else if (hours.wday?.[weekdayKey]?.ftid && hours.wday?.[weekdayKey]?.ttid) {
                            resolvedHours = hours.wday[weekdayKey];
                            status = 'weekday';
                        } else if (hours.ftid && hours.ttid) {
                            resolvedHours = {
                                ftid: hours.ftid,
                                ttid: hours.ttid,
                            };
                            status = 'default';
                        }

                        return (
                            <div
                                key={dateStr}
                                onClick={() => {if(write)setOpenDay({date: dateStr, hours: resolvedHours, status:status, menu})}}
                                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                role="button"
                            >
                                <div className="flex-grow-1">
                                    <strong>{dayjs(dateStr).format('D MMMM')}</strong>{" "}
                                    <small className="text-muted">({dayjs(dateStr).format('dddd')})</small>
                                </div>
                                {menu &&
                                <div>
                                    <strong>Special meny </strong>
                                    {menu.ftid && (
                                        <small className="border border-dark border-1 rounded-pill px-2">
                                            {menu.ftid.slice(0, 2)}:{menu.ftid.slice(2)}
                                            {menu.ttid && ` – ${menu.ttid.slice(0, 2)}:${menu.ttid.slice(2)}`}
                                        </small>
                                    )}
                                </div>
                                }
                                <div className=" text-end">
                                    {status === 'closed' ? (
                                        <span className="badge bg-danger">Stängt</span>
                                    ) : resolvedHours ? (
                                        <span className={`badge ${status === 'special' ? 'bg-success' : 'bg-secondary'}`}>
                        {resolvedHours.ftid.slice(0, 2)}:{resolvedHours.ftid.slice(2)} – {resolvedHours.ttid.slice(0, 2)}:{resolvedHours.ttid.slice(2)}
                    </span>
                                    ) : (
                                        <span className="text-muted">Inga tider</span>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                </div>

                <PageButtons/>
                <DayModal item={openDay} setItem={setOpenDay}/>
            </div>
        );
    }


    return (
        <div className="container">
            <h1 className="mb-4">Öppettider</h1>

            {/* Allmänna tider */}
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">
                        <h3 className="card-title mb-4">Allmänna tider</h3>
                        {changedGeneral && write && (
                            <button className="btn btn-success" onClick={handleSave}>
                                <i className="bi bi-save me-2"></i>Spara
                            </button>
                        )}
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                        <TimeInput
                            path="ftid"
                            value={hours.ftid || ''}
                            onChange={handleHourChange}
                        />
                        <h3 className="mb-0">-</h3>
                        <TimeInput
                            path="ttid"
                            value={hours.ttid || ''}
                            onChange={handleHourChange}
                        />
                    </div>
                </div>


                {/* Weekdays */}
                {hours.wday && (
                    <div className="card-body">
                        <h4 className="card-title mb-2">Veckodagar</h4>
                        {["1","2","3","4","5","6","7"].map((item) => {
                            const value = hours.wday[item] ?? hours;
                            return (
                                <div key={item} className="border rounded mb-3 p-2 bg-light">
                                    <div>
                                        <div className="d-flex gap-2 align-items-center mb-2">
                                            <h6>{Number(item).getWeekday()}</h6>
                                            {hours.wday[item] && write &&
                                                <button className="btn btn-secondary" style={{fontSize: "12px"}} onClick={()=>{
                                                    setHours(prev => ({
                                                        ...prev,
                                                        wday: {
                                                            ...prev.wday,
                                                            [item]: null
                                                        }
                                                    }))
                                                    setChangedGeneral(true)
                                                }}><i
                                                    className="bi bi-arrow-clockwise"></i> Återställ</button>}
                                        </div>
                                        <div className="d-flex gap-2 align-items-center">
                                            <TimeInput
                                                path={`wday.${item}.ftid`}
                                                value={value.ftid}
                                                onChange={handleHourChange}
                                                showLabel={false}
                                            />
                                            <h3 className="mb-0">-</h3>
                                            <TimeInput
                                                path={`wday.${item}.ttid`}
                                                value={value.ttid}
                                                onChange={handleHourChange}
                                                showLabel={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            )}
            </div>

            <div className="card mb-4 shadow-sm">
                <div className="card-body">


                <div className="d-flex justify-content-between align-items-start">
                    <h3 className="card-title mb-4">Kalender</h3>
                    {changedCalender && write && (
                        <button className="btn btn-success" onClick={handleSave}>
                            <i className="bi bi-save me-2"></i>Spara
                        </button>
                    )}
                </div>
                    <CalenderOC hours={hours} menu={specialMenu}/>
                </div>
            </div>

        </div>
    );

}
